import { actions as resourceActions, ListResourcesResult } from '@ff-os/pdp-shared-redux/slices/resourcesSlice';
import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { urls } from '@ff-os/shared-utils/urls';
import fetch from 'cross-fetch';

export const preloadResources = async (store: PdpStore) => {

    const { scene } = store.getState();
    const resources = await loadResources(scene.id, 'prefab');

    store.dispatch(resourceActions.replace(resources));
};

const loadResources = async (sceneId: string, type: string): Promise<ListResourcesResult> => {

    const url = urls.listResources(sceneId, type);

    const response = await fetch(url);
    if (response.status !== 200) {
        throw new Error(`[${response.status}] Failed to load resources for scene ID "${sceneId}" from "${url}"`);
    }

    const jsonResponse = await response.json();
    return { resourceType: type, entries: jsonResponse.entries };
};